const ACTION = 'index.php?route=extension/seo/seo/ecommerce';

export default function ecommerce() {
	document.addEventListener('add-to-cart', async function(event) {
		const {detail} = event;
		const item = await getItem(detail);
		if (!item) return;

		dataLayer.push({ ecommerce: null });
		dataLayer.push({
			event: "add_to_cart",
			ecommerce: {
				items: [item]
			},
			value: item.price * item.quantity,
			items: [{
				id: item.id,
				google_business_vertical: "retail"
			}]
		});
	});

	document.addEventListener('remove-from-cart', async function(event) {
		const {detail} = event;
		const item = await getItem(detail);
		if (!item) return;

		dataLayer.push({ ecommerce: null });
		dataLayer.push({
			event: "remove_from_cart",
			ecommerce: {
				items: [item]
			}
		});
	});

	document.addEventListener('change-quantity-cart', async function(event) {
		const {detail} = event;
		const item = await getItem(detail);
		if (!item) return;

		const quantity = +detail.get('quantity');
		const newQuantity = +detail.get('new_quantity');

		let e = 'remove_from_cart';

		if (newQuantity > quantity) {
			item.quantity = newQuantity - quantity;
			e = 'add_to_cart';
		} else {
			item.quantity = quantity - newQuantity;
		}

		dataLayer.push({ ecommerce: null });
		dataLayer.push({
			event: e,
			ecommerce: {
				items: [item]
			}
		});
	});

	document.addEventListener('confirm', async function(event) {
		const data = await getConfirmData();
		if (!data) return;

		dataLayer.push({ ecommerce: null });
		dataLayer.push(data);

		event.detail.resolve();
	});

	document.addEventListener('call-back', async function(event) {
		const {detail} = event;

		dataLayer.push({ ecommerce: null });
		dataLayer.push({
			event: 'call_back',
			value: 0,
			currency: "UAH",
			user_data: {
				email: null,
				phone_number: detail.phone,
				first_name: detail.name,
			}
		});
	});

	document.addEventListener('fast-order', async function(event) {
		const {detail} = event;
		const data = await getFastOrderData(detail);
		if (!data) return;

		dataLayer.push({ ecommerce: null });
		dataLayer.push(data);
	})
}

const getItem = async function (detail) {
	try {
		const response = await fetch(`${ACTION}.getItem`, {
			method: 'POST',
			body: detail,
		});

		if (!response.ok) {
			throw new Error(`Request failed: ${response.status}`);
		}

		const result = await response.json();

		return result.item;
	} catch (e) {
		console.error(e);
	}

	return null;
}

const getConfirmData = async function () {
	try {
		const response = await fetch(`${ACTION}.getConfirmData`);

		if (!response.ok) {
			throw new Error(`Request failed: ${response.status}`);
		}

		return await response.json();
	} catch (e) {
		console.error(e);
	}

	return null;
};

const getFastOrderData = async function (data) {
	try {
		const response = await fetch(`${ACTION}.getFastOrderData`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data),
		});

		if (!response.ok) {
			throw new Error(`Request failed: ${response.status}`);
		}

		return await response.json();
	} catch (e) {
		console.error(e);
	}

	return null;
};
